import { observer } from "mobx-react"
import React, { useState, useEffect, memo } from "react"
import "../../App.less"
import benifitsJson from "../../Configs/JSON/benifits.json"
import BenefitStore from "../../Configs/Store/benefit"
import AppStore from "../../Configs/Store/index"
import "../../styles/Benefits/Benefit.less"
import "../../styles/Benefits/ResultBlock.less"
import { addCommas } from "../Common/CommonFunctions"
import BenefitHeadText from "../Common/GenericComponenetHeader"
import InputSlider from "../Common/InputSlider"
import SavingsIcon from "../../assets/savings_last_icon.svg"
// import IncomeGap from "assets/Steps/CardInfoIcon.svg"
import CalculatorStore from "../../Configs/Store/calculator"
import KnowMoreModal from "../GuaranteedIncome/KnowMoreModal"
import ChartModal from "../GuaranteedIncome/ChartModal"
import { UserInput } from "../../Configs/API/calculation"
import { DataLayerFn } from "../../Configs/API"
import RetirmentPlans from "../RetirmentPlans/RetirmentPlans"
import incomePlan from "../../Configs/JSON/incomePlan.json"
import GenericModal from "../Common/GenericModal"
import { ageValidation } from "../../Configs/Validator/FormValidations"
import MobileModal from "./MobileModal"
import FormStore from "../../Configs/Store/forms"
import commonStor from "../../Configs/Store/common"

const RetirementAgeSlider = memo(function RetirementAgeSlider({ handleAgeVal }) {
  return (
    <>
      <InputSlider handleAgeVal={handleAgeVal} />
      <span className="inf">The retirement age must be more than your current age</span>
    </>
  )
})

const ResultBlock = observer((props) => {
  const device = AppStore.device
  const url = "https://www.icicilife.com/insurance-plans/buy-life-insurance-online.html?UID=38114"
  // let chart = null
  let benifitContainer = null
  let benifitContainerOnlyPC = null
  let benifitandTitleContainer = null
  let [likeList, setLikeList] = useState("")
  let [hover, setHover] = useState(false)
  let [savingChartData, setSavingChartData] = useState([])
  let [postRetirementChartData, setPostRetirementChartData] = useState([])
  let CurrentSavingsValue = []
  let PostRetirementExpensesValue = []
  let graphAgeValue = []

  useEffect(() => {
    CalculatorStore.setIncomeProp(false)
  }, [])

  const RenderLikeList = () => {
    return <div className="IncomeGap">Additional savings (adjusted for growth) when you retire minus expenses (adjusted for inflation) at the time of retirement.</div>
  }
  // const handleLeave = () => {
  //   // setLikeList("")
  //   setHover(false)
  // }
  // const handleHover = () => {
  //   setHover(true)
  //   // setLikeList(renderLikeList())
  // }
  const handleClick = () => {
    if (AppStore.device === 0) {
      FormStore.setMobileModal(true)
    }
  }

  if (device === 0) {
    benifitContainer = "benifitsMobileContainer benifits-container"
    benifitContainerOnlyPC = null
    benifitandTitleContainer = "benifitandTitleContainerMob"
  } else {
    benifitContainer = "benifitsPCContainer benifits-container"
    benifitContainerOnlyPC = "benifitContainerOnlyPC"
  }

  const handleFirstButtonTab = () => {
    CalculatorStore.setUniqueInflationRates(0)
    CalculatorStore.setShowPlans(false)

    CalculatorStore.uniqueInflationRates = 0
    UserInput("uniqueInflationRate", 0, "", "")
    CalculatorStore.setSurviveTillAge(0)
    CalculatorStore.surviveTillAge = 0
    UserInput("surviveTill", 0, "", "")

    CalculatorStore.setIsDisabled(false)
    CalculatorStore.setFifthScreenFlag(false)
    CalculatorStore.setRetireCalcFlag(true)
    CalculatorStore.setValsNew(0)
    CalculatorStore.setShowData(0)
    CalculatorStore.setscreenNo("Scr1")
    UserInput("screen", "Scr1", "", "")
    CalculatorStore.setCustomRange1Text("Age")
    CalculatorStore.setCalcPageScrn("first")
    CalculatorStore.setminValue(18)
    CalculatorStore.setRangeInput(43)
    CalculatorStore.setbgSize(((43 - 18) / (CalculatorStore.maxValue - 18)) * 100)
    let ageValidations = ageValidation(43, CalculatorStore.minValue, CalculatorStore.maxValue)
    CalculatorStore.setErrorAge(ageValidations.valid)
    CalculatorStore.setErrorMessage(ageValidations.errorMsg)

    CalculatorStore.setAgeValue(43)
    UserInput("age", 43, "", "")
    CalculatorStore.setAccurateResultValue(0)
    CalculatorStore.setAccurateResultValueHouse(0)
    CalculatorStore.setAccurateResultValueFood(0)
    CalculatorStore.setAccurateResultValueTransport(0)
    CalculatorStore.setAccurateResultValueEntertainment(0)
    CalculatorStore.setAccurateResultValueMiscellaneous(0)
    UserInput("CE", 0, "CE_Entertainment", "")
    UserInput("CE", 0, "CE_FoodUtilitiesBills", "")
    UserInput("CE", 0, "CE_Housing", "")
    UserInput("CE", 0, "CE_Miscellaneous", "")
    UserInput("CE", 0, "CE_Transport", "")
    UserInput("CS", 0, "CS_FixedDepositTaxable", "")
    UserInput("CS", 0, "CS_LifeInsurancePolicies", "")
    UserInput("CS", 0, "CS_Others", "")
    UserInput("CS", 0, "CS_ProvidendFund", "")
    UserInput("CS", 0, "CS_StocksMutualFundTaxable", "")
    UserInput("PRE", 0, "PRE_Entertainment", "")
    UserInput("PRE", 0, "PRE_FoodUtilitiesBills", "")
    UserInput("PRE", 0, "PRE_Housing", "")
    UserInput("PRE", 0, "PRE_Miscellaneous", "")
    UserInput("PRE", 0, "PRE_Transport", "")
    CalculatorStore.setcurrentExpensesValue1(0)
    UserInput("currentExpenses", 0, "", "")
    CalculatorStore.setcurrentExpensesValue2(0)
    UserInput("postRetirementExpenses", 0, "", "")
    CalculatorStore.setcurrentExpensesValue3(0)
    UserInput("currentSavings", 0, "", "")
    UserInput("savingsGrowthRate", 0, "", "")
    CalculatorStore.setRetireAgeValue(60)
    UserInput("ageOfRetirement", 60, "", "")
    CalculatorStore.setTotalAmtAtRetire(0)
    UserInput("totalAmountAtRetirement", 0, "", "")
    CalculatorStore.setExpensesAmtAtRetire(0)
    UserInput("expensesAmountAtRetirement", 0, "", "")
    CalculatorStore.setSavingsAmtAtRetire(0)
    UserInput("savingsAmountAtRetirement", 0, "", "")
    CalculatorStore.setAdditionalSavingsAmtAtRetire(0)
    UserInput("additionalSavingsAmountAtRetirement", 0, "", "")
    CalculatorStore.setFirstYearAdditionalSavingsAmtAtRetire(0)
    UserInput("firstYearAdditionalSavingsAmountAtRetirement", 0, "", "")
    CalculatorStore.setAgeTillRetirement(0)
    UserInput("ageTillRetirement", 0, "", "")
    CalculatorStore.setAdditionalAmtAtRetire(0)
    UserInput("additionalAmtAtRetire", 0, "", "")
    CalculatorStore.setIncomeProp(true)

    try {
      DataLayerFn("Recalculate_Selected", CalculatorStore, "Recalculate")
    } catch {}
  }

  const handleYourGraph = () => {
    GraphValues()
    try {
      DataLayerFn("YourGraph_Selected", CalculatorStore, "Your Graph")
    } catch {}
    try {
      DataLayerFn("YourGraph_Open", CalculatorStore, "")
    } catch {}
  }

  const GraphValues = () => {
    CalculatorStore.CashFlowValue.map((data, i) => {
      CurrentSavingsValue[i] = parseInt(CalculatorStore.CashFlowValue[i].CurrentSavings)
      // if (CalculatorStore.CashFlowValue.length != i + 1)
      PostRetirementExpensesValue[i] = parseInt(CalculatorStore.CashFlowValue[i].PostRetirementExpenses)
      graphAgeValue[i] = parseInt(CalculatorStore.CashFlowValue[i].Age)
      // console.log("----", i)

      return [CurrentSavingsValue, PostRetirementExpensesValue, graphAgeValue]
    })
    console.log("CurrentSavingsValue--", CurrentSavingsValue)
    console.log("PostRetirementExpensesValue", PostRetirementExpensesValue)
    console.log("age--", graphAgeValue)

    var minValIndexForSaving = CurrentSavingsValue.findIndex((val) => val !== 0)
    var minValIndexForExpense = PostRetirementExpensesValue.findIndex((val) => val !== 0)
    var maxValIndexForSaving = CurrentSavingsValue.length - CurrentSavingsValue.reverse().findIndex((val) => val !== 0) - 1
    var maxValIndexForExpense = PostRetirementExpensesValue.length - PostRetirementExpensesValue.reverse().findIndex((val) => val !== 0) - 1
    var minIndexAge = Math.min(minValIndexForSaving, minValIndexForExpense)
    var maxIndexAge = Math.max(maxValIndexForSaving, maxValIndexForExpense)
    PostRetirementExpensesValue.reverse()
    CurrentSavingsValue.reverse()
    var newAgeValues = graphAgeValue.slice(minIndexAge, maxIndexAge + 1)
    var newCurrentSavingsValue = CurrentSavingsValue.slice(minValIndexForSaving, maxValIndexForSaving + 1)
    var newPostRetirementExpenseValue = PostRetirementExpensesValue.slice(minIndexAge, maxIndexAge + 1)

    console.log("minAge - ", minIndexAge)
    console.log("maxAge - ", maxIndexAge)
    console.log("newagevalues - ", newAgeValues)
    console.log("newCurrentSavingsValue - ", newCurrentSavingsValue)
    console.log("newPostRetirementExpenseValue - ", newPostRetirementExpenseValue)

    setSavingChartData(
      newAgeValues.map((item, index) => {
        return { Age: item.toString(), Amount: newCurrentSavingsValue[index], type: "Savings" }
      })
    )
    setPostRetirementChartData(
      newAgeValues.map((item, index) => {
        return { Age: item.toString(), Amount: newPostRetirementExpenseValue[index], type: "Post-Retirement Expenses" }
      })
    )

    // CalculatorStore.setChartOptions({
    //   title: {
    //     text: "Savings vs Post-Retirement Expenses",
    //     align: "left",
    //     x: 40,
    //     style: {
    //       fontWeight: 700,
    //       fontSize: "16px",
    //       lineHeight: "20px",
    //       color: "#1E1E1E",
    //       fontFamily: "Mulish",
    //     },
    //   },
    //   series: [
    //     {
    //       name: "Post-Retirement Expenses",
    //       data: newPostRetirementExpenseValue,
    //     },
    //     {
    //       name: "Savings",
    //       data: newCurrentSavingsValue,
    //     },
    //   ],
    //   chart: {
    //     type: "column",
    //   },
    //   colors: ["#DE6335", "#094B7F"],
    //   xAxis: {
    //     categories: newAgeValues,
    //     crosshair: true,
    //     title: {
    //       text: "Age",
    //     },
    //   },
    //   yAxis: {
    //     min: 0,
    //     labels: {
    //       formatter: function () {
    //         return "₹" + this.axis.defaultLabelFormatter.call(this)
    //       },
    //       x: 0,
    //       y: 0,
    //     },
    //     title: {
    //       text: "",
    //     },
    //   },
    //   legend: {
    //     align: "right",
    //     verticalAlign: "top",
    //     layout: "horizontal",
    //     x: 0,
    //     y: 0,
    //   },
    // })

    // chart.reflow();
  }

  const handlePlanYourRetirement = () => {
    CalculatorStore.setShowPlans(true)
    // document.querySelector(".RetirmentPlansRoot").scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
    window.scrollBy({
      top: 200,
      left: 0,
      behavior: "smooth",
    })

    try {
      DataLayerFn("PlanYourRetirement_Selected", CalculatorStore, "Plan Your Retirement")
    } catch {}
  }

  const handleKnowMore = () => {
    try {
      DataLayerFn("KnowMore_Selected", CalculatorStore, "Know More")
    } catch {}
  }

  return (
    <div className={benifitandTitleContainer}>
      {device === 0 && (
        <BenefitHeadText
          content={benifitsJson["BHTTitleText"]}
          icon={true}
          onClick={() => {
            BenefitStore.setAddBenefitModal(true)
          }}
        />
      )}
      {device === 0 && (
        <div className={benifitContainerOnlyPC}>
          <div className={benifitContainer}>
            <div className="mobile-wrap">
              <div className="row">
                <div className="col-md-6 order-1 order-md-1 br-rt" nextscrbutton={CalculatorStore.screenNo}>
                  <div className="col-md-6 order-2 TopContainer">
                    <div className="srcn-wrap style-for-mob" nextscrbutton={CalculatorStore.screenNo}>
                      <div className="ttl-2Head">
                        <div className="ttl-2">{incomePlan["Heading4"]}</div>
                        <div className="sb-ttl-1">{incomePlan["Heading2"]}</div>
                      </div>

                      <div className="media saving-blk">
                        <div className="saving-blk-img">
                          <img src={SavingsIcon} className="" alt="icon" />
                        </div>
                        <div className="media-body">
                          {Math.round(CalculatorStore.expensesAmtAtRetire) <= Math.round(CalculatorStore.savingsAmtAtRetire) && <h4>Congratulations!</h4>}
                          {Math.round(CalculatorStore.expensesAmtAtRetire) > Math.round(CalculatorStore.savingsAmtAtRetire) && <p className="ttl">Your current savings would last till</p>}
                          {Math.round(CalculatorStore.expensesAmtAtRetire) <= Math.round(CalculatorStore.savingsAmtAtRetire) && (
                            <p className="ttl text-center">You have saved enough for your retirement</p>
                          )}
                        </div>
                        {Math.round(CalculatorStore.expensesAmtAtRetire) > Math.round(CalculatorStore.savingsAmtAtRetire) && <p className="age">{CalculatorStore.surviveTillAge} years of age</p>}
                      </div>
                      {Math.round(CalculatorStore.expensesAmtAtRetire) < Math.round(CalculatorStore.savingsAmtAtRetire) && (
                        <div className="additional-savings-blk">
                          <p className="ttl">You have enough and an additional amount per month of</p>
                          <p className="amt">₹ {addCommas(Math.round(CalculatorStore.additionalSavingsAmtAtRetire))}</p>
                          <p className="sb-ttl">to enjoy your retirement</p>
                          <div
                            className="bttn-lnk" // back-bttn back st"
                            data-toggle="modal"
                            data-target="#exampleModalCenter"
                            onClick={handleKnowMore}
                          >
                            Know More
                          </div>
                          <div className="media infl-blk">
                            <span className="bl br-rt w-50">
                              <p className="p">Expected rate of inflation is {CalculatorStore.uniqueInflationRates}%</p>
                            </span>
                            <span className="bl br-rt w-50 sec-span">
                              {CalculatorStore.ageRetireCalc === true && <p className="p">You exceed your retirement age by {CalculatorStore.ageTillRetirement.toString().replace("-", "")} years</p>}
                              {CalculatorStore.ageRetireCalc === false && <p className="p">Years left for retirement is {CalculatorStore.ageTillRetirement} years</p>}
                            </span>
                          </div>
                        </div>
                      )}
                      {Math.round(CalculatorStore.expensesAmtAtRetire) > Math.round(CalculatorStore.savingsAmtAtRetire) && (
                        <div className="additional-savings-blk">
                          <p className="ttl">You need additional savings of</p>
                          <p className="amt">₹ {addCommas(Math.round(CalculatorStore.additionalAmtAtRetire))}</p>
                          <p className="sb-ttl">to serve your retirement needs</p>
                          <div
                            className="bttn-lnk" // back-bttn back st"
                            data-toggle="modal"
                            data-target="#exampleModalCenter"
                            onClick={handleKnowMore}
                          >
                            Know More
                          </div>
                          <div className="media infl-blk">
                            <span className="bl br-rt w-50">
                              <p className="p">Expected rate of inflation is {CalculatorStore.uniqueInflationRates}%</p>
                            </span>
                            <span className="bl br-rt w-50 sec-span">
                              {CalculatorStore.ageRetireCalc === true && <p className="p">You exceed your retirement age by {CalculatorStore.ageTillRetirement.toString().replace("-", "")} years</p>}
                              {CalculatorStore.ageRetireCalc === false && <p className="p">Years left for retirement is {CalculatorStore.ageTillRetirement} years</p>}
                            </span>
                          </div>
                        </div>
                      )}
                      {Math.round(CalculatorStore.expensesAmtAtRetire) === Math.round(CalculatorStore.savingsAmtAtRetire) && (
                        <div className="additional-savings-blk">
                          <p className="ttl">You have enough savings </p>
                          <p className="sb-ttl">to enjoy your retirement</p>
                          <div
                            className="bttn-lnk" // back-bttn back st"
                            data-toggle="modal"
                            data-target="#exampleModalCenter"
                            onClick={handleKnowMore}
                          >
                            Know More
                          </div>
                          <div className="media infl-blk">
                            <span className="bl br-rt w-50">
                              <p className="p">Expected rate of inflation is {CalculatorStore.uniqueInflationRates}%</p>
                            </span>
                            <span className="bl br-rt w-50 sec-span">
                              {CalculatorStore.ageRetireCalc === true && <p className="p">You exceed your retirement age by {CalculatorStore.ageTillRetirement.toString().replace("-", "")} years</p>}
                              {CalculatorStore.ageRetireCalc === false && <p className="p">Years left for retirement is {CalculatorStore.ageTillRetirement} years</p>}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="results-wrap">
                    <ul className="list-unstyled results-blocks">
                      <li className="media">
                        <div className="media-body">
                          <p className="p">At the time of retirement you will have a total of</p>
                        </div>
                        <span className="amt">₹ {addCommas(Math.round(CalculatorStore.totalAmtAtRetire))}</span>
                      </li>
                      <li className="media">
                        <div className="media-body">
                          <p className="p">Your expenses at retirement will be </p>
                        </div>
                        <span className="amt">
                          ₹ {addCommas(Math.round(CalculatorStore.expensesAmtAtRetire))}
                          <span>per month</span>
                        </span>
                      </li>
                      <li className="media">
                        <div className="media-body">
                          <p className="p">Your current savings would generate an amount of </p>
                        </div>
                        <span className="amt">
                          ₹ {addCommas(Math.round(CalculatorStore.savingsAmtAtRetire))}
                          <span>per month</span>
                        </span>
                      </li>
                      <li className="media">
                        <div className="media-body">
                          {Math.round(CalculatorStore.expensesAmtAtRetire) > Math.round(CalculatorStore.savingsAmtAtRetire) && (
                            <div className="p">
                              <b>Income Gap :</b> Amount you are falling short of
                              <div className="likes__relavance ml-2" onClick={handleClick}>
                                {" "}
                                <img src={"assets/Steps/CardInfoIcon.svg"} className="ml-lg-2 mb-lg-1 mb-0 ml-1" alt="icon" width="17" /> {likeList}{" "}
                              </div>
                            </div>
                          )}
                          {Math.round(CalculatorStore.expensesAmtAtRetire) <= Math.round(CalculatorStore.savingsAmtAtRetire) && (
                            <p className="p">You have enough amount to serve your monthly needs after retirement</p>
                          )}
                        </div>
                        <span className="amt">
                          ₹ {addCommas(Math.round(CalculatorStore.additionalSavingsAmtAtRetire))}
                          <span>per month</span>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <RetirementAgeSlider handleAgeVal={props.handleAgeVal} />
                  <div className="row justify-content-between">
                    <div className="col-auto">
                      <button className="btn bttn-icon st" onClick={handleFirstButtonTab}>
                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                        <span>Recalculate</span>
                      </button>
                    </div>
                    <div className="col-auto">
                      <button type="button" className="btn bttn-icon st" data-toggle="modal" data-target="#yourGraphModal" onClick={handleYourGraph}>
                        <i className="fa fa-signal" aria-hidden="true"></i>
                        <span>Your Graph</span>
                      </button>
                    </div>
                  </div>
                  <div className="checkRetirement">
                    <button
                      className="btn bttn-lg bttn-primary nextButton style-mob-mt-25 st"
                      onClick={handlePlanYourRetirement}
                      style={{
                        backgroundColor: CalculatorStore.ShowPlans === true && "gray",
                        cursor: CalculatorStore.ShowPlans === true && "not-allowed",
                      }}
                    >
                      <div>Plan Your Retirement </div>
                      <div className="RetirementChild">
                        <div className="RetirementArrow"></div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
              {CalculatorStore.screenNo === "Scr6" && CalculatorStore.ShowPlans === true && <RetirmentPlans />}
            </div>
          </div>
        </div>
      )}
      {device === 1 && (
        <div className={benifitContainerOnlyPC}>
          <div className={benifitContainer} style={{ marginTop: "10px" }}>
            <div className="mobile-wrap">
              <div className="row">
                <div className="col-md-6 order-1 order-md-1 br-rt" nextscrbutton={CalculatorStore.screenNo}>
                  <div className="results-wrap">
                    <ul className="list-unstyled results-blocks">
                      <li className="media">
                        <div className="media-body">
                          <p className="p">At the time of retirement you will have a total of</p>
                        </div>
                        <span className="amt">₹ {addCommas(Math.round(CalculatorStore.totalAmtAtRetire))}</span>
                      </li>
                      <li className="media">
                        <div className="media-body">
                          <p className="p">Your expenses at retirement will be </p>
                        </div>
                        <span className="amt">
                          ₹ {addCommas(Math.round(CalculatorStore.expensesAmtAtRetire))}
                          <span>per month</span>
                        </span>
                      </li>
                      <li className="media">
                        <div className="media-body">
                          <p className="p">Your current savings would generate an amount of </p>
                        </div>
                        <span className="amt">
                          ₹ {addCommas(Math.round(CalculatorStore.savingsAmtAtRetire))}
                          <span>per month</span>
                        </span>
                      </li>
                      <li className="media">
                        <div className="media-body">
                          {Math.round(CalculatorStore.expensesAmtAtRetire) > Math.round(CalculatorStore.savingsAmtAtRetire) && (
                            <div className="p">
                              <b>Income Gap :</b> Amount you are falling short of
                              <div
                                className="likes__relavance ml-2"
                                onMouseOver={() => setHover(true)}
                                onMouseLeave={() => setHover(false)}
                                // onClick={() => setHover(true)}
                              >
                                {" "}
                                <img src={"assets/Steps/CardInfoIcon.svg"} className="ml-lg-2 mb-lg-1 mb-0 ml-1" alt="icon" width="17" /> {likeList} {hover && <RenderLikeList />}
                              </div>
                            </div>
                          )}
                          {Math.round(CalculatorStore.expensesAmtAtRetire) <= Math.round(CalculatorStore.savingsAmtAtRetire) && (
                            <p className="p">You have enough amount to serve your monthly needs after retirement</p>
                          )}
                        </div>
                        <span className="amt">
                          ₹ {addCommas(Math.round(CalculatorStore.additionalSavingsAmtAtRetire))}
                          <span>per month</span>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <RetirementAgeSlider handleAgeVal={props.handleAgeVal} />
                </div>

                <div className="col-md-6 order-2">
                  <div className="srcn-wrap style-for-mob" nextscrbutton={CalculatorStore.screenNo}>
                    <div className="media saving-blk">
                      <div className="saving-blk-img">
                        <img src={SavingsIcon} className="" alt="icon" />
                      </div>
                      <div className="media-body">
                        {Math.round(CalculatorStore.expensesAmtAtRetire) <= Math.round(CalculatorStore.savingsAmtAtRetire) && <h4>Congratulations!</h4>}
                        {Math.round(CalculatorStore.expensesAmtAtRetire) > Math.round(CalculatorStore.savingsAmtAtRetire) && <p className="ttl">Your current savings would last till</p>}
                        {Math.round(CalculatorStore.expensesAmtAtRetire) <= Math.round(CalculatorStore.savingsAmtAtRetire) && (
                          <p className="ttl text-center">You have saved enough for your retirement</p>
                        )}
                      </div>
                      {Math.round(CalculatorStore.expensesAmtAtRetire) > Math.round(CalculatorStore.savingsAmtAtRetire) && <p className="age">{CalculatorStore.surviveTillAge} years of age</p>}
                    </div>
                    {Math.round(CalculatorStore.expensesAmtAtRetire) < Math.round(CalculatorStore.savingsAmtAtRetire) && (
                      <div className="additional-savings-blk">
                        <p className="ttl">You have enough and an additional amount per month of</p>
                        <p className="amt">₹ {addCommas(Math.round(CalculatorStore.additionalSavingsAmtAtRetire))}</p>
                        <p className="sb-ttl">to enjoy your retirement</p>
                        <div
                          className="bttn-lnk" // back-bttn back st"
                          data-toggle="modal"
                          data-target="#exampleModalCenter"
                          onClick={handleKnowMore}
                        >
                          Know More
                        </div>
                        <div className="media infl-blk">
                          <span className="bl br-rt w-50">
                            <p className="p">Expected rate of inflation is {CalculatorStore.uniqueInflationRates}%</p>
                          </span>
                          <span className="bl br-rt w-50 sec-span">
                            {CalculatorStore.ageRetireCalc === true && <p className="p">You exceed your retirement age by {CalculatorStore.ageTillRetirement.toString().replace("-", "")} years</p>}
                            {CalculatorStore.ageRetireCalc === false && <p className="p">Years left for retirement is {CalculatorStore.ageTillRetirement} years</p>}
                          </span>
                        </div>
                      </div>
                    )}
                    {Math.round(CalculatorStore.expensesAmtAtRetire) > Math.round(CalculatorStore.savingsAmtAtRetire) && (
                      <div className="additional-savings-blk">
                        <p className="ttl">You need additional savings of</p>
                        <p className="amt">₹ {addCommas(Math.round(CalculatorStore.additionalAmtAtRetire))}</p>
                        <p className="sb-ttl">to serve your retirement needs</p>
                        <div
                          className="bttn-lnk" // back-bttn back st"
                          data-toggle="modal"
                          data-target="#exampleModalCenter"
                          onClick={handleKnowMore}
                        >
                          Know More
                        </div>
                        <div className="media infl-blk">
                          <span className="bl br-rt w-50">
                            <p className="p">Expected rate of inflation is {CalculatorStore.uniqueInflationRates}%</p>
                          </span>
                          <span className="bl br-rt w-50 sec-span">
                            {CalculatorStore.ageRetireCalc === true && <p className="p">You exceed your retirement age by {CalculatorStore.ageTillRetirement.toString().replace("-", "")} years</p>}
                            {CalculatorStore.ageRetireCalc === false && <p className="p">Years left for retirement is {CalculatorStore.ageTillRetirement} years</p>}
                          </span>
                        </div>
                      </div>
                    )}
                    {Math.round(CalculatorStore.expensesAmtAtRetire) === Math.round(CalculatorStore.savingsAmtAtRetire) && (
                      <div className="additional-savings-blk">
                        <p className="ttl">You have enough savings </p>
                        <p className="sb-ttl">to enjoy your retirement</p>
                        <div
                          className="bttn-lnk" // back-bttn back st"
                          data-toggle="modal"
                          data-target="#exampleModalCenter"
                          onClick={handleKnowMore}
                        >
                          Know More
                        </div>
                        <div className="media infl-blk">
                          <span className="bl br-rt w-50">
                            <p className="p">Expected rate of inflation is {CalculatorStore.uniqueInflationRates}%</p>
                          </span>
                          <span className="bl br-rt w-50 sec-span">
                            {CalculatorStore.ageRetireCalc === true && <p className="p">You exceed your retirement age by {CalculatorStore.ageTillRetirement.toString().replace("-", "")} years</p>}
                            {CalculatorStore.ageRetireCalc === false && (
                              <p className="p w-100 text-center">
                                <p className="p"></p>
                                Years left for retirement is {CalculatorStore.ageTillRetirement} years
                              </p>
                            )}
                          </span>
                        </div>
                      </div>
                    )}

                    <div className="row justify-content-between">
                      <div className="col-auto">
                        <button className="btn bttn-icon st" onClick={handleFirstButtonTab}>
                          <i className="fa fa-chevron-left" aria-hidden="true"></i>
                          <span>Recalculate</span>
                        </button>
                      </div>
                      <div className="col-auto">
                        <button type="button" className="btn bttn-icon st" data-toggle="modal" data-target="#yourGraphModal" onClick={handleYourGraph}>
                          <i className="fa fa-signal" aria-hidden="true"></i>
                          <span>Your Graph</span>
                        </button>
                      </div>
                    </div>
                    <div className="checkRetirement">
                      <button
                        className="btn bttn-lg bttn-primary nextButton style-mob-mt-25 st"
                        onClick={handlePlanYourRetirement}
                        style={{
                          backgroundColor: CalculatorStore.ShowPlans === true && "gray",
                          cursor: CalculatorStore.ShowPlans === true && "not-allowed",
                        }}
                      >
                        <div>Plan Your Retirement </div>
                        <div className="RetirementChild">
                          <div className="RetirementArrow"></div>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {CalculatorStore.screenNo === "Scr6" && CalculatorStore.ShowPlans === true && <RetirmentPlans />}
            </div>
          </div>
        </div>
      )}
      <MobileModal />

      <KnowMoreModal />
      <ChartModal data={[...savingChartData, ...postRetirementChartData]} />
    </div>
  )
})
export default ResultBlock
